import { FlowInfo } from './flow-info.model';
import { WorkFlowFileInfo } from './work-flow-file-info.model';
export class WorkFlowBatchInfo {
  workFlowId?: number;
  flowInfos?: Array<FlowInfo>;
  attachFiles?: Array<WorkFlowFileInfo>;
}
